import React, {
    useRef,
    useEffect,
    forwardRef,
    useImperativeHandle,
    useState,
  } from "react";
  
  const NumericCellEditor = forwardRef((props, ref) => {
    const inputRef = useRef();
    const [value, setValue] = useState(props.value || "");
    const [decimalDigits, setDecimalDigits] = useState(props.decimalDigits || 0);
    const maxValue = props.maxValue;
  
    // Focus input on start
    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, []);
  
    // ✅ Expose required methods to AG Grid
    useImperativeHandle(ref, () => ({
      getValue() {
        const val = Number(value);
        if (isNaN(val)) return 0;
        if (maxValue != null && val > maxValue) return maxValue;
        return val;
      },
    }));
  
    const onKeyDown = (e) => {
      // Allow control/navigation keys
      if (["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)) {
        return;
      }
  
      if (e.key === "Enter") {
        props.stopEditing();
        return;
      }
      if (e.key === "Escape") {
        props.stopEditing(true);
        return;
      }
  
      // Allow only digits and dot
      if (!/^[0-9.]$/.test(e.key)) {
        e.preventDefault();
      }
    };
  
    const onBlur = () => {
      props.stopEditing();
    };
  
    
  const handleChange = (e) => {
    let input = e.target.value;

    // Allow only digits and one dot
    if (!/^[0-9]*\.?[0-9]*$/.test(input)) return;

    // Block dot if decimals not allowed
    if (decimalDigits === 0 && input.includes(".")) return;

    // Restrict number of digits after decimal
    if (decimalDigits > 0 && input.includes(".")) {
      const [integerPart, decimalPart] = input.split(".");
      if (decimalPart.length > decimalDigits) return;
    }

    setValue(input);
  };

    return (
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => handleChange(e)}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          textAlign: "right",
        }}
      />
    );
  });
  
  export default NumericCellEditor;
  